import React, { Component } from "react";
import {
  BrowserRouter,
  Route,
  Router,
  Redirect,
  Switch,
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";

import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./pages/home/home";
import ShareBtn from "./components/sharebtn";
import LiveMatrix from "./pages/tools/livematrix/livematrix";
import WarrantSelector from "./pages/tools/warrantselector/selector";
import WarrantSearch from "./pages/tools/warrantsearch/search";
import WarrantTerms from "./pages/tools/warrantterm/term";
import WarrantCalculator from "./pages/tools/warrantcalculator/calculator";
import WarrantComparison from "./pages/tools/warrantcomparison/comparison";
import UnderlyingChart from "./pages/tools/underlyingchart/underlyingchart";
import WarrantDocument from "./pages/tools/warrantdocument/document";
import Telegram from "./pages/marketnews/telegram/telegram";
import DailyHigh from "./pages/marketnews/dailyhighlights/dailyhigh";
import OverHight from "./pages/marketnews/overnight/overnight";
import Subscribe from "./pages/marketnews/subscribe/subscribe";
import Gallery from "./pages/marketnews/photogallery/gallery";
import GetStarted from "./pages/education/getstarted/started";
import Brochure from "./pages/education/brochure/brochure";
import SuccessSpeaks from "./pages/education/successspeaks/speaks";
import FAQ from "./pages/education/faq/faq";
import Seminar from "./pages/education/seminar/seminar";
import Hstech from "./pages/education/hstech/hstech";
import TopTraded from "./pages/marketdata/toptradedwarrant/toptraded";
import TopGainer from "./pages/marketdata/topgainer/topgainer";
import DWTurnover from "./pages/marketdata/dwturnover/dwturnover";
import TurnoverDist from "./pages/marketdata/turnoverdist/turnoverdist";
import EducationVideo from "./pages/education/educationvideos/warrantvideos";
import ShortFormVideos from "./pages/education/shortFormVideos/warrantvideos";
import IndexFuturesRollover from "./pages/education/IndexFuturesRollover";
import MarketView from "./pages/education/educationvideos/marketview";
import MarketCommentary from "./pages/education/marketcommentary/commentary";
import HighLight from "./pages/marketnews/highlight/highlight";
import IndividualGallery from "./pages/marketnews/individualgallery/individualgallery";
import Whymacquarie from "./pages/education/whymacquarie/whymacquarie";
import Indexwarrants from "./pages/education/indexwarrants/indexwarrants";
import Submission from "./components/SurveyPage";

import ImportantInformation from "./pages/bottomPage/importantInformation/importantInformation";
import Termsofuse from "./pages/bottomPage/termsOfUse/termsOfUse";
import Contactus from "./pages/bottomPage/contactUs/contactUs";
import Disclaimer from "./pages/bottomPage/disclaimer/disclaimer";
import Disclaimerr from "./pages/bottomPage/disclaimerr/disclaimerr";
import Privacypolicy from "./components/privacypolicy";

import Search from "./pages/home/search/search";

// Investor Academy
import InvestorAcademy from "./pages/investorAcademy/eduhtml";

import Sp500 from "./pages/education/sp500/sp500";
import Sgxtradingfestival from "./components/sgxtradingfestival/sgxtradingfestival";
import UnSubscribe from "./components/UnSubscribe/UnSubscribe";
// import SiMSCI from "./components/SiMSCI/SiMSCI";
import Sitemap from "./components/sitemap/sitemap";
import StockWarrantPage from "./components/stockWarrantPage/";

// import createHistory from 'history/createBrowserHistory'
import { createBrowserHistory } from "history";
import ReactGA from "react-ga4";
const history = createBrowserHistory();
ReactGA.initialize("G-6VGY7GKL9V");
history.listen((location, action) => {
  ReactGA.send({ page: location.pathname + location.search });
});
// --- Matomo 集成步骤 1: 引入 Hook ---
// 请确保 useMatomo.js 文件在 src/hooks/ 目录下
import useMatomo from "./hooks/useMatomo";
// --- Matomo 集成步骤 2: 创建一个函数组件包装器 ---
// 因为 App 是 Class Component，不能直接用 Hook，所以需要这个中间件
const MatomoTracker = () => {
  useMatomo(); // 调用监听路由的 Hook
  return null; // 这个组件不渲染任何 UI
};

export default class App extends Component {
  componentDidMount() {
    ReactGA.send({ page: location.pathname + location.search });
  }
  render() {
    let isGuidebook = true;
    isGuidebook =
      window.location.href.toLocaleLowerCase().indexOf("guidebook") == -1;
    return (
      <div>
        <Router history={history}>
          {/* 
          [Matomo集成] 3. 使用 Tracker 
          因为它在 index.js 的 <BrowserRouter> 内部，所以这里可以正常工作。
        */}
          <MatomoTracker />
          <ScrollToTop>
            <div>
              {isGuidebook ? <Header /> : null}
              {/* <Header/>
              <ShareBtn /> */}
              {isGuidebook ? <ShareBtn /> : null}
              <Switch>
                {/* InvestorAcademy */}
                <Route
                  path="/WarrantsGuidebook/:ticker"
                  render={(props) => <InvestorAcademy {...props} />}
                ></Route>

                <Route
                  path="/WarrantsGuidebook"
                  component={InvestorAcademy}
                ></Route>
                <Route path="/submission" component={Submission}></Route>
                {/* <Route path="/education/SiMSCI" component={SiMSCI}></Route> */}
                <Route path="/Sitemap" component={Sitemap}></Route>
                <Route path="/UnSubscribe" component={UnSubscribe}></Route>
                <Redirect from="/LandingPage" to="/home" />

                {/* home */}
                <Route path="/home" component={Home}></Route>
                {/* tools */}
                <Route
                  path="/tools/livematrix/:ticker"
                  render={(props) => <LiveMatrix {...props} />}
                ></Route>
                <Route path="/tools/livematrix" component={LiveMatrix}></Route>
                <Route
                  path="/tools/selector"
                  component={WarrantSelector}
                ></Route>
                <Route
                  exact
                  path="/tools/warrantsearch"
                  component={WarrantSearch}
                ></Route>

                <Route
                  path="/tools/warrantterms/:ticker"
                  render={(props) => <LiveMatrix {...props} />}
                ></Route>
                <Route
                  path="/tools/warrantterms"
                  component={LiveMatrix}
                ></Route>
                <Route
                  path="/tools/HistoricalPerformance/:ticker"
                  render={(props) => <LiveMatrix {...props} />}
                ></Route>
                <Route
                  path="/tools/HistoricalPerformance"
                  component={LiveMatrix}
                ></Route>
                <Route
                  path="/tools/exposuresimulator/:ticker"
                  render={(props) => <LiveMatrix {...props} />}
                ></Route>
                <Route
                  path="/tools/exposuresimulator"
                  component={LiveMatrix}
                ></Route>
                <Route
                  path="/tools/warrantcalculator/:ticker"
                  render={(props) => <LiveMatrix {...props} />}
                ></Route>
                <Route
                  path="/tools/warrantcalculator"
                  component={LiveMatrix}
                ></Route>

                <Route
                  path="/tools/underlying/:ticker"
                  render={(props) => <UnderlyingChart {...props} />}
                ></Route>
                <Route
                  path="/tools/underlying"
                  component={UnderlyingChart}
                ></Route>
                <Route
                  path="/tools/warrantcomparison"
                  component={WarrantComparison}
                ></Route>
                <Route
                  path="/tools/document"
                  component={WarrantDocument}
                ></Route>
                {/* marketnews */}
                <Route path="/telegram" component={Telegram}></Route>
                <Route
                  path="/marketnews/highlight/:cat/:id"
                  render={(props) => <HighLight {...props} />}
                ></Route>
                <Route
                  path="/marketnews/dailyhighlights/:underlying"
                  render={(props) => <DailyHigh {...props} />}
                ></Route>
                <Route
                  path="/marketnews/dailyhighlights"
                  component={DailyHigh}
                ></Route>
                <Route
                  path="/marketnews/overnightmarkets"
                  component={OverHight}
                ></Route>
                <Route
                  path="/marketnews/subscribe"
                  component={Subscribe}
                ></Route>
                <Route
                  path="/marketnews/photogallery"
                  component={Gallery}
                ></Route>
                <Route
                  path="/marketnews/individualgallery/:id"
                  render={(props) => <IndividualGallery {...props} />}
                ></Route>
                {/* warrant education */}
                <Route
                  path="/education/getstarted"
                  component={GetStarted}
                ></Route>
                <Route
                  path="/education/Indexfuturesrollover"
                  component={IndexFuturesRollover}
                ></Route>
                <Route
                  path="/education/warrantvideos"
                  component={EducationVideo}
                ></Route>
                <Route
                  path="/education/shortFormVideos"
                  component={ShortFormVideos}
                ></Route>
                <Route
                  path="/education/marketcommentary/:subtitle/:id/:index"
                  render={(props) => <MarketCommentary {...props} />}
                ></Route>
                <Route
                  path="/education/marketcommentary/:subtitle/:id"
                  render={(props) => <MarketCommentary {...props} />}
                ></Route>
                <Route
                  path="/education/marketcommentary"
                  component={MarketCommentary}
                ></Route>
                <Route path="/education/brochure" component={Brochure}></Route>
                <Route path="/SuccessSpeaks" component={SuccessSpeaks}></Route>
                <Route
                  path="/education/marketview"
                  component={MarketView}
                ></Route>
                <Route path="/education/faq" component={FAQ}></Route>
                <Route path="/education/seminar" component={Seminar}></Route>
                <Route path="/education/hstech" component={Hstech}></Route>
                <Route
                  path="/education/whymacquarie"
                  component={Whymacquarie}
                ></Route>
                <Route
                  path="/education/indexETFwarrants/:ticker"
                  component={Indexwarrants}
                ></Route>
                <Route
                  path="/education/indexETFwarrants"
                  component={Indexwarrants}
                ></Route>
                <Route
                  path="/education/StockWarrantPage"
                  component={StockWarrantPage}
                ></Route>
                {/* warrant statistics */}
                <Route
                  path="/marketdata/toptradedwarrants"
                  exact
                  component={TopTraded}
                ></Route>
                <Route
                  path="/marketdata/toptradedwarrants/:tab"
                  exact
                  render={(props) => <TopTraded {...props} />}
                ></Route>
                <Route
                  path="/marketdata/topgainloss"
                  exact
                  render={(props) => <TopGainer {...props} />}
                ></Route>
                <Route
                  path="/marketdata/topgainloss/:tab"
                  exact
                  render={(props) => <TopGainer {...props} />}
                ></Route>
                <Route
                  path="/marketdata/topgainloss/:tab/:day"
                  exact
                  render={(props) => <TopGainer {...props} />}
                ></Route>
                <Route
                  path="/marketdata/turnover"
                  component={DWTurnover}
                ></Route>
                <Route
                  path="/marketdata/turnoverdist"
                  component={TurnoverDist}
                ></Route>

                <Route
                  path="/about/importantInformation"
                  component={ImportantInformation}
                ></Route>

                <Route path="/about/disclaimer" component={Disclaimer}></Route>

                <Route path="/about/contactus" component={Contactus}></Route>

                <Route path="/about/termsofuse" component={Termsofuse}></Route>

                <Route
                  path="/about/disclaimerr"
                  component={Disclaimerr}
                ></Route>
                <Route path="/edu/" component={Disclaimerr}></Route>
                <Route
                  path="/about/privacypolicy"
                  component={Privacypolicy}
                ></Route>

                <Route path="/search" component={Search}></Route>
                {/* 如果找不到页面则会跳转至home */}
                <Redirect to="/home" />
              </Switch>
              {/* <Footer /> */}
              {isGuidebook  ? <Footer /> : null}
            </div>
          </ScrollToTop>
        </Router>
      </div>
    );
  }
}
